import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


// Custom Modules 
import { ApprovalsSearchModule } from '@app/components/sections/approvals/search/search.module';
import { AppVersionsModule } from '@app/components/sections/versions/versions.module';
// import { AppHelpersSearchModule } from '@app/components/helpers/search/search.module';
import { HelpersModule } from '@core/components/helpers/helpers.module';
import { LayoutModule } from '@core/components/layout/layout.module';
import { VersionsModule } from '@core/components/versions/versions.module';

// Custom components
import { ApprovalsMainComponent } from '@app/components/sections/approvals/main/main.component';
import { ApprovalsResultsComponent } from './results/results.component';
import { ApprovalsStatusMenuComponent } from './status-menu/main.component';

@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    ApprovalsSearchModule,
    // AppHelpersSearchModule,
    HelpersModule,
    LayoutModule,
    VersionsModule,
    AppVersionsModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  declarations: [
    ApprovalsMainComponent,
    ApprovalsResultsComponent,
    ApprovalsStatusMenuComponent
  ],
})
export class ApprovalsModule { }
